import React, { useState } from "react";
import "./payment-method-selector.css"; // Estilo CSS para el componente

import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { Image } from "semantic-ui-react";

const PaymentMethodSelector = ({ paymentMethods, onConfirm }) => {
  const [selectedMethod, setSelectedMethod] = useState(null);

  const handleSelect = (method) => {
    setSelectedMethod(method);
    onConfirm(method); // Llamar a la función onConfirm con el método seleccionado
  };

  return (
    <div className="payment-method-selector">
      <Container fluid>
        <Row className="justify-content-center p-3 pt-4">
          {paymentMethods &&
            paymentMethods.map((method) => (
              <Col xs={12} sm={6} md={4} key={method.id}>
                <div
                  className={`payment-method ${
                    selectedMethod?.method === method?.method ? "selected" : ""
                  }`}
                  onClick={() => handleSelect(method)}
                >
                  <input
                    type="radio"
                    id={method.id}
                    name="paymentMethod"
                    value={method.id}
                    checked={selectedMethod === method}
                    onChange={() => {}}
                  />
                  <label htmlFor={method.id}>
                    <Card
                      className={`shadow payment-card ${
                        selectedMethod === method ? "selected" : ""
                      }`}
                    >
                      <img src={method.logo} alt={method.name} wrapped ui={false} />
                      <CardBody className="border-top text-center">
                        <h3>{method.name}</h3>
                      </CardBody>
                    </Card>
                  </label>
                </div>
              </Col>
            ))}
        </Row>
      </Container>
    </div>
  );
};

export default PaymentMethodSelector;
